import Swiper from 'swiper';
import { Navigation, Pagination, FreeMode } from 'swiper/modules';

// import swiper styles bundle
import 'swiper/css/bundle';

// Import Swiper and required modules
document.addEventListener('DOMContentLoaded', function () {
  const testimonialSlider = new Swiper('.testimonial-slider', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: '.testimonial-slider-next',
      prevEl: '.testimonial-slider-prev',
    },
    pagination: {
      el: '.testimonial-slider-pagination',
      clickable: true,
    },
  });

  const gallerySlider = new Swiper('.gallery-slider', {
    modules: [Navigation, Pagination, FreeMode],
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: true,
    freeMode: {
      enabled: false,
      sticky: true,
    },
    navigation: {
      nextEl: '.gallery-slider-next',
      prevEl: '.gallery-slider-prev',
    },
    pagination: {
      el: '.gallery-slider-pagination',
      clickable: true,
    },
    grabCursor: true,
  });

  console.log('Swiper sliders initialized');
});
